export default "/_next/static/fonts/cb8c0f5bd500a04140d5be0c72e40f94.woff";